export default __webpack_public_path__ + "static/media/invisibleW.8ade3057.svg";